"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupBy = void 0;
var GroupBy;
(function (GroupBy) {
    GroupBy[GroupBy["day"] = 10] = "day";
    GroupBy[GroupBy["hour"] = 13] = "hour";
    GroupBy[GroupBy["minutes"] = 19] = "minutes";
})(GroupBy = exports.GroupBy || (exports.GroupBy = {}));
class DateTransformer {
    constructor(input, groupBy = GroupBy.day) {
        this.data = {};
        for (const item of input) {
            const { start_at, end_at, ...row } = item;
            const startHour = start_at.slice(0, groupBy);
            const endHour = end_at.slice(0, groupBy);
            if (!this.data[startHour]) {
                this.data[startHour] = { starts: [], ends: [] };
            }
            if (!this.data[endHour]) {
                this.data[endHour] = { starts: [], ends: [] };
            }
            const newItem = { start_at, end_at, row };
            this.data[startHour].starts.push(newItem);
            this.data[endHour].ends.push(newItem);
        }
    }
    all() {
        return this.data;
    }
}
exports.default = DateTransformer;
//# sourceMappingURL=DateTransformer.js.map